export default "<div class=\"site-sidebar\">\n    <logo></logo>\n    <main-menu></main-menu>\n</div>\n<!-- <div class=\"sidebar-overlay\"></div> -->\n";